import type { Lesson } from '../../models/Lesson';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, title, subject, class, language, content, video_url, region_id, school_id, class_id, subject_id, created_at, updated_at`;

export class LessonRepository extends SupabaseRepository<Lesson> {
  constructor(client: SupabaseClient) {
    super('lessons', selector, client);
  }
}


